import React, { Fragment, useEffect, useState, useContext } from 'react'
import { Link, withRouter } from 'react-router-dom'
import { useHistory, useLocation, useRouteMatch } from 'react-router';
import styled, { css } from 'styled-components';
import { Context } from '../context';
import { getMetadataCategories, getDataById, handleUrl } from './utils';
import { ContentInfoLine } from './ContentInfo';
import uniqid from "uniqid";
import { UIinput } from '../uikit/UIinput';
import { UIemojiSelect } from '../uikit/UIemojiSelect';
import { UIbutton } from '../uikit/Uikit';
import './gs_add.css';
import { UItoggle } from '../uikit/UItoggle';


export function MetadataThreads({ videoId, handleClick = () => void (0) }) {
  const history = useHistory();
  const location = useLocation();
  const match = useRouteMatch();


  const handleCreate = () => {
    console.log('match = ', match);
    handleUrl(history, match, videoId, 'create')
    // history.push(`${location['pathname']}create`)
  }


  const context = useContext(Context);

  const [query, setQuery] = useState('');


  return (
    <>

      <div className="l_content_info_section">
        <div className="l_info_line">

          <div className="flex middle">


          <div className="l_video_info_title">
            Metadata threads
          </div>

            <div
              className="x_meta_actions"
            >
              <UIbutton sm xs flat
                onClick={() => handleCreate()}

              >Add</UIbutton>
            </div>

          </div>
        </div>


        <div className="l_info_line">

          {Boolean(getMetadataCategories(context, videoId, true, false, true).length) &&
            getMetadataCategories(context, videoId, true, false, true)
              .map((typeRef) => {
                // debugger
                return (<>
                  {typeRef && <ContentInfoLine
                    // key={`metadata_info_${typeRef['id']}`}
                    videoId={videoId}
                    key={`metadata_${uniqid()}`}
                    typeRef={typeRef}
                    handleClick={handleClick}
                  // frame={frame}
                  // handleFrame={(n) => {
                  //   setFrame(Math.floor(n));
                  // }}
                  // {...props}
                  />}
                </>
                );
              })}


          {/* <div className="l_info_line">
            <div className="flex">
              <div className="l_info_sum0">
                <div className="x_meta_anchorlink" onClick={() => handleCreate()}>
                  <div className="x_meta_hover" />
                  <div className="x_meta_addthread">
                    <div className="x_meta_add_ico">
                      <div className="ico">
                        <div>add</div>
                      </div>
                    </div>
                    <div>Add new thread</div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}






        </div>
      </div>





    </>
  )
}





